import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

// Externals
import PropTypes from 'prop-types';
import classNames from 'classnames';
import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import TextField from '@material-ui/core/TextField/index';
import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import Grid from '@material-ui/core/Grid';
import FormHelperText from '@material-ui/core/FormHelperText';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import IconButton from '@material-ui/core/IconButton/index';
import CircularProgress from '@material-ui/core/CircularProgress/index';


// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';

// Component styles
import styles from './styles';

import { api_host } from '../../../../common/globals/constants';

import md5 from 'md5';





// Service methods
const updateValues = (updateValues) => {
    let token = sessionStorage.getItem('key')
    let user_id = sessionStorage.getItem('user')

    updateValues["user"] = user_id
    updateValues["token"] = token
    
    return new Promise(resolve => {
        setTimeout(() => {
            fetch(api_host+'/reporte/general/perfil/', {
                method: 'PATCH', // or 'PUT'
                body: JSON.stringify(updateValues), // data can be `string` or {object}!
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(res => res.json())
                .catch(error => console.error('Error:', error))
                .then(response => {
                    if (response.status == 1) {
                        resolve(false);
                    } else {
                        resolve(true);
                    }
                }
                );
        }, 5000);
    });
};


class Profile extends Component {

    constructor(props) {
        super(props)
        this.state = {
            values: {
                currentPass: '',
                newPass: '',
                confirmPass: '',
                confirm: '',
                timezone: '',
                email: '',
                name: '',
                phone: '',
                position: '', 
                interval: '',
                sound: '',
                orientation: ''
            },
            timezone: {},
            timezonedefault: {},
            userObject: {},
            isLoading: true,
            isValid: false, 
            isOpen: false,
            typeSnackbar: 0
        };
    }

    componentDidMount() {
        this.getDataFromAPI();
    }

    getDataFromAPI = (objectiveId) => {

        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        const { history } = this.props;
        Promise.all([
            fetch(api_host+`/reporte/general/perfil/?user=${user}&token=${token}&start=${new Date().getTime()}`),
            fetch(api_host+`/reporte/general/intervalos_y_zona_horaria/?token=${token}&start=${new Date().getTime()}`)
        ])
            .then(([res1, res2]) => {
                return Promise.all([res1.json(), res2.json()])
            })
            .then(([res1, res2]) => {
                // Se define el state de acuerdo a la petición y respuesta de la promesa 
                if (res1.status == 1 || res1.status == 5 || res2.status == 1 || res2.status == 5) {
                    localStorage.setItem('isAuthenticated', false);
                } else {
                    //Procesa la Data Recibida
                    try {
                        this.processData(res1, res2)
                    } catch (error) {
                        this.setState({
                            dataError: true,
                            data: null,
                            isLoading: false,
                            isValid: false,
                            isOpen: true,
                            typeSnackbar: 1
                        });
                    }
                }
            });
     
    }

   // Helper para procesar la data de la petición a la API

    processData = (res1, res2) => {

        var interval = []
        var isSoundActive = false
        var soundLabel = 'Apagado'
        var orientation = 0
        var orientationLabel = 'Normal'
 
        Object.keys(res2['intervalos']).map((key) => {  
            if (parseInt(res2['intervalos'][key].valor) == res1['periodo_semaforo']){
                interval.push(res2['intervalos'][key])
            }
        })

        if (res1['cliente_usuario_extendido'] != null){
            if (res1['cliente_usuario_extendido'].sonido_semaforo){
                isSoundActive = true
                soundLabel = 'Encendido'
            }
        }

    
        if (res1['preferencia_semaforo_orientacion'] != 0 ){
            orientation = 1
            orientationLabel = 'Invertido'
        }

        this.setState({
            timezone: res2['zona_horaria'],
            userObject: res1,
            interval: res2['intervalos'],
            isLoading: false,
            isValid: false,
            values: {
                currentPass: '',
                newPass: '',
                confirmPass: '',
                confirm: '',
                timezone: {label: res1['zona_horaria'].nombre, value: res1['zona_horaria'].zona_horaria_id },
                email: res1['email'],
                name: res1['nombre'],
                phone: res1['telefono'],
                position: res1['cargo'],
                interval: {label: interval[0].nombre, value: interval[0].valor},
                sound: {label: soundLabel, value: isSoundActive},
                orientation: {label: orientationLabel, value: orientation}
            },
            isOpen: false,
            typeSnackbar: 0
            

        });

    }

    handleFieldChange = (field, value) => {

        const newState = { ...this.state };
        newState.values[field] = value;     
        this.setState(newState);
    };

    handleValidate = async () => {
        var contChanges = 0
        var isValidManager = false
        var isValidName = false
        var isValidPass = false
        var newPass = ''
        let updateValuesList = {}
        const { values, userObject } = this.state;

        try {

            // validar nombre
            if (values.name === ''){
                isValidManager = false
                ///error
            } else {
                if (values.name === userObject.nombre){
                    isValidManager = true
                    isValidName = true
                } else {
                    isValidManager = true
                    isValidName = true
                    contChanges = contChanges + 1
                    updateValuesList['nombre'] = values.name
                }
            }
            
            //validar pass
            if (values.newPass != '' && values.currentPass != '' && values.confirmPass != '') {
                if (md5(values.currentPass) == userObject['clave']) {
                    if (md5(values.newPass) == values.currentPass){
                        //error
                        isValidManager = false
                        isValidPass = false
                    } else {
                        if (values.newPass != values.confirmPass) {
                            isValidManager = false
                            isValidPass = false
                            //error
                        } else {
                            isValidManager = true
                            isValidPass = true
                            contChanges = contChanges + 1
                            newPass = md5(values.newPass)
                            updateValuesList['clave'] = newPass
                        }
                    }
                } else {
                    //error
                    isValidManager = false
                    isValidPass = false
                }
            } else if (values.newPass == '' && values.currentPass == '' && values.confirmPass == '') {
                isValidManager = true
                isValidPass = true
            } else {
                if (values.currentPass != '') {
                    //error
                    isValidManager = false
                    isValidPass = false
                }
                if (values.newPass != '') {
                    //error
                    isValidManager = false
                    isValidPass = false
                }
                if (values.confirmPass != '') {
                    //error
                    isValidManager = false
                    isValidPass = false
                }
            }
           
            if (isValidName && isValidPass && isValidManager){

                //validar telefono
                if (values.phone != userObject.telefono){
                    contChanges = contChanges + 1
                    isValidManager = true
                    updateValuesList['telefono'] = values.phone
                }

                //validar cargo
                if (values.position != userObject.cargo){
                    contChanges = contChanges + 1
                    isValidManager = true
                    updateValuesList['cargo'] =  values.position
                }
                
                //validar peridos
                if (typeof(values.interval.value) == "undefined"){
                    if (parseInt(values.interval) != userObject.periodo_semaforo){
                        contChanges = contChanges + 1
                        isValidManager = true
                        updateValuesList['preferencia_semaforo_periodo'] = values.interval
                    }
                } else {
                    if (parseInt(values.interval.value) != userObject.periodo_semaforo){
                        contChanges = contChanges + 1
                        isValidManager = true
                        updateValuesList['preferencia_semaforo_periodo'] = values.interval.value
                    }
                }

                //validar sonido
                if (typeof(values.sound.value) == "undefined"){
                    if (values.sound != userObject.cliente_usuario_extendido.sonido_semaforo){
                        contChanges = contChanges + 1
                        isValidManager = true
                        updateValuesList['cliente_usuario_extendido'] = values.sound
                    }
                } else {
                    if (values.sound.value != userObject.cliente_usuario_extendido.sonido_semaforo){
                        contChanges = contChanges + 1
                        isValidManager = true
                        updateValuesList['cliente_usuario_extendido'] = values.sound.value
                    }
                }

                //validar zona horaria
                if (typeof(values.timezone.value) == "undefined"){
                    if (parseInt(values.timezone) != userObject.zona_horaria.zona_horaria_id){
                        contChanges = contChanges + 1
                        isValidManager = true
                        updateValuesList['zona_horaria'] = values.timezone
                    }
                } else {
                    if (parseInt(values.timezone.value) != userObject.zona_horaria.zona_horaria_id){
                        contChanges = contChanges + 1
                        isValidManager = true
                        updateValuesList['zona_horaria'] = values.timezone.value
                    }
                }

                 //validar orientación
                if (typeof(values.orientation.value) == "undefined"){
                    if (parseInt(values.orientation) != userObject.preferencia_semaforo_orientacion){
                        contChanges = contChanges + 1
                        isValidManager = true
                        updateValuesList['preferencia_semaforo_orientacion'] = values.orientation
                    }
                } else {
                    if (parseInt(values.orientation.value) != userObject.preferencia_semaforo_orientacion){
                        contChanges = contChanges + 1
                        isValidManager = true
                        updateValuesList['preferencia_semaforo_orientacion'] = values.orientation.value
                    }
                }
            }
            //realizar consulta para actualizar
            if (isValidManager && (contChanges > 0)) {
                try {
                    this.setState({ isLoading: true });
                    await updateValues(updateValuesList);
                    //window.location.reload()
                    this.setState({
                        //isLoading: false,
                        isValid: false,
                        isOpen: true,
                        typeSnackbar: 0
                    });
                } catch (error) { 
                    this.setState({
                        isLoading: false,
                        isValid: false,
                        isOpen: true,
                        typeSnackbar: 2
                    });
                }
            } else {
                this.setState({
                    isLoading: false,
                    isValid: false,
                    isOpen: true,
                    typeSnackbar: 1
                 });
            }
        } catch (error) {
            this.setState({
                isLoading: false,
                serviceError: error,
                isValid: false,
                isOpen: true,
                typeSnackbar: 2
            });
        }
    };

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        this.setState({
            isLoading: false,
            isOpen: false 
        })
        this.getDataFromAPI();
      };

    render() {
        const { classes, className, t, ...rest } = this.props;
        const { values, timezone, userObject, isLoading, isValid, isOpen, typeSnackbar, interval, sound } = this.state;


        const rootClassName = classNames(classes.root, className);

        return (
            <Portlet
                {...rest}
                className={rootClassName}
            >
                <PortletHeader>
                    <PortletLabel
                        //subtitle="Actualizar Pérfil"
                        title={t('settings.profile.title')}
                    />
                </PortletHeader>
                <PortletContent>
                    <Grid
                        container
                        spacing={10}
                    >
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={4}
                            xl={4} 
                        >
                            <Portlet
                                {...rest}
                                className={rootClassName}
                            >
                                <PortletHeader style={{backgroundColor: '#ECECEC', borderTopRightRadius: 10, borderTopLeftRadius: 10}}>
                                    <PortletLabel
                                        title={t('settings.profile.myProfile')}
                                    />
                                </PortletHeader>
                                <PortletContent>
                                    <form className={classes.form}>
                                        <TextField
                                            className={classes.textField}
                                            label={t('settings.profile.name')}
                                            name="name"
                                            type="text"
                                            value={values.name}
                                            variant="outlined"
                                            onChange={event =>
                                                this.handleFieldChange('name', event.target.value)
                                            }
                                            style={{marginTop: 20}}
                                        />
                                        <TextField
                                            className={classes.textField}
                                            label={t('settings.profile.email')}
                                            name="email"
                                            type="email"
                                            value={values.email}
                                            variant="outlined"
                                            disabled={true}
                                        />
                                        <TextField
                                            className={classes.textField}
                                            label={t('settings.profile.phone')}
                                            name="phone"
                                            type="text"
                                            value={values.phone}
                                            variant="outlined"
                                            inputProps={{ pattern:'\x2b[0-9]+' }}
                                            onChange={event =>
                                                this.handleFieldChange('phone', event.target.value)
                                            }
                                        />
                                        <TextField
                                            className={classes.textField}
                                            label={t('settings.profile.position')}
                                            name="position"
                                            type="text"
                                            value={values.position}
                                            variant="outlined"
                                            onChange={event =>
                                                this.handleFieldChange('position', event.target.value)
                                            }
                                        />
                                        <FormControl className={classes.formControl}>   
                                            <InputLabel shrink htmlFor="age-native-label-placeholder">
                                            {t('settings.profile.timezoneLabel')}
                                            </InputLabel>
                                            { isLoading ? <div></div> : 
                                                <NativeSelect
                                                    className={classes.textField}
                                                    onChange={event =>
                                                        this.handleFieldChange('timezone', event.target.value)
                                                    }
                                                    defaultValue={values.timezone.value}
                                                    inputProps={{
                                                        name: 'name',
                                                        id: 'uncontrolled-native',
                                                    }}
                                                >
                                                    {Object.keys(timezone).map((key) => {                                                        
                                                        return <option value={timezone[key]['zona_horaria_id']}>{timezone[key]['nombre']}</option>
                                                    })}

                                                </NativeSelect>}
                                           
                                        </FormControl>
                                    </form>
                                </PortletContent>
                            </Portlet>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={4}
                            xl={4} 
                        >
                            <Portlet
                                {...rest}
                                className={rootClassName}
                            >
                                <PortletHeader style={{backgroundColor: '#ECECEC', borderTopRightRadius: 10, borderTopLeftRadius: 10}}>
                                    <PortletLabel
                                        title={t('settings.profile.systemConfig')}
                                    />
                                </PortletHeader>
                                <PortletContent>
                                    <form className={classes.form}>
                                        <FormControl className={classes.formControl} style={{marginTop: 20}}>   
                                                <InputLabel htmlFor="age-native-helper">{t('settings.profile.intervalLabel')}</InputLabel>

                                                { isLoading ? <div></div> : 
                                                    <NativeSelect
                                                        className={classes.textField}
                                                        onChange={event =>
                                                            this.handleFieldChange('interval', event.target.value)
                                                        }
                                                        defaultValue={values.interval.value}
                                                        inputProps={{
                                                            name: 'name',
                                                            id: 'uncontrolled-native',
                                                        }}
                                                    >
                                                        {Object.keys(interval).map((key) => {                                                        
                                                            return <option value={interval[key]['valor']}>{t('intervals', {returnObjects: true})?.[key]?.['nombre'] ?? 'N/I'}</option>
                                                        })}

                                                    </NativeSelect>}


                                        </FormControl>
                                        <FormControl className={classes.formControl}>   
                                            <InputLabel htmlFor="age-native-helper">{t('settings.profile.orientationLabel')}</InputLabel>
                                            <NativeSelect
                                                className={classes.textField}
                                                //value="orientación semaforo"
                                                name="orientation"
                                                onChange={event =>
                                                    this.handleFieldChange('orientation', event.target.value)
                                                }
                                                value={values.orientation.value}
                                                variant="outlined"
                                            >
                                                <option value={0}>{t('settings.profile.orientationOptions.normal')}</option>
                                                <option value={1}>{t('settings.profile.orientationOptions.inverted')}</option>
                                            </NativeSelect>
                                        </FormControl>
                                        <FormControl className={classes.formControl}>   
                                            <InputLabel htmlFor="age-native-helper">{t('settings.profile.soundLabel')}</InputLabel>
                                            <NativeSelect
                                                className={classes.textField}
                                                //value="Sonido semaforo"
                                                name="sound"
                                                onChange={event =>
                                                    this.handleFieldChange('sound', event.target.value)
                                                }
                                                value={values.sound.value}
                                                variant="outlined"
                                            >
                                                <option value={false}>{t('settings.profile.soundOptions.off')}</option>
                                                <option value={true}>{t('settings.profile.soundOptions.on')}</option>
                                            </NativeSelect>
                                        </FormControl>
                                        <FormHelperText>{t('settings.profile.helper1')}</FormHelperText>
                                        <FormHelperText>{t('settings.profile.helper2')}</FormHelperText>               
                                    </form>
                                </PortletContent>
                                
                            </Portlet>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={4}
                            xl={4} 
                        >
                            <Portlet
                                {...rest}
                                className={rootClassName}
                            >
                                <PortletHeader style={{backgroundColor: '#ECECEC', borderTopRightRadius: 10, borderTopLeftRadius: 10}}>
                                    <PortletLabel
                                        title={t('settings.profile.passwordSection')}
                                    />
                                </PortletHeader>
                                <PortletContent>
                                    <form className={classes.form}>
                                        <TextField
                                            className={classes.textField}
                                            label={t('settings.profile.password.current')}
                                            name="currentPass"
                                            onChange={event =>
                                                this.handleFieldChange('currentPass', event.target.value)
                                            }
                                            type="password"
                                            value={values.currentPass}
                                            variant="outlined"
                                            style={{marginTop: 20}}
                                        />
                                        <TextField
                                            className={classes.textField}
                                            label={t('settings.profile.password.new')}
                                            name="newPass"
                                            onChange={event =>
                                                this.handleFieldChange('newPass', event.target.value)
                                            }
                                            type="password"
                                            value={values.newPass}
                                            variant="outlined"
                                        />
                                        <TextField
                                            className={classes.textField}
                                            label={t('settings.profile.password.confirm')}
                                            name="confirmPass"
                                            onChange={event =>
                                                this.handleFieldChange('confirmPass', event.target.value)
                                            }
                                            type="password"
                                            value={values.confirmPass}
                                            variant="outlined"
                                        />
                                         <FormHelperText>{t('settings.profile.passwordHelper')}</FormHelperText>
                                    </form>
                                    
                                </PortletContent>
                            </Portlet>
                        </Grid>
                    </Grid>
                </PortletContent>
                <PortletFooter className={classes.portletFooter} align="right">
                    {isLoading ? (
                        <CircularProgress className={classes.progress} />
                    ) : (
                        <Button
                            style={{backgroundColor:"#FF8B32", color:"white"}}
                            variant="outlined"
                            onClick={this.handleValidate}
                        >
                            {t('text.update')}
                        </Button>
                    )}
                    {isValid ? (
                        null
                    ) : (
                        <Snackbar
                                anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                                }}
                                open={isOpen}
                                autoHideDuration={2000}
                                onClose={this.handleClose}
                            >
                                <SnackbarPer t={t} typeSnackbar={typeSnackbar} classes={classes} className={className} handleClose={this.handleClose}/>

                        </Snackbar>
                            
                    )}
                </PortletFooter>
            </Portlet>
        );
    }
}

Profile.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired
};

function SnackbarPer(props) {
    if (props.typeSnackbar == 0){
        return <SnackbarContent
            className={props.classes.snackContentOk}
            aria-describedby="client-snackbar"
            message={
                <span id="client-snackbar" className={props.classes.message}>
                    <CheckCircleIcon className={(props.classes.icon, props.classes.iconVariant)}/>
                    {props.t('settings.profile.snackbar.success')}
                </span>
            }
            action={[
                <IconButton key="close" aria-label="close" color="inherit" onClick={props.handleClose}>
                    <CloseIcon className={props.classes.icon}/>
                </IconButton>
            ]}
        />
    }
    if (props.typeSnackbar == 1){
        return <SnackbarContent
            className={props.classes.snackContentError}
            aria-describedby="client-snackbar"
            message={
                <span id="client-snackbar" className={props.classes.message}>
                    <ErrorIcon className={(props.classes.icon, props.classes.iconVariant)}/>
                    {props.t('settings.profile.snackbar.nochange')}
                </span>
            }
            action={[
                <IconButton key="close" aria-label="close" color="inherit" onClick={props.handleClose}>
                    <CloseIcon className={props.classes.icon}/>
                </IconButton>
            ]}
        />
    }
    if (props.typeSnackbar == 2){
        return <SnackbarContent
            className={props.classes.snackContentWarning}
            aria-describedby="client-snackbar"
            message={
                <span id="client-snackbar" className={props.classes.message}>
                    <InfoIcon className={(props.classes.icon, props.classes.iconVariant)}/>
                    {props.t('settings.profile.snackbar.error')}
                </span>
            }
            action={[
                <IconButton key="close" aria-label="close" color="inherit" onClick={props.handleClose}>
                    <CloseIcon className={props.classes.icon}/>
                </IconButton>
            ]}
        />
    }

    
}

export default compose(withRouter, withStyles(styles), withTranslation())(Profile);
